module.exports = __webpack_public_path__ + "static/img/Anglian-Chem-3.b57cb1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Anglian-Chem-3.jpg
// module id = XmxV
// module chunks = 0